import React, {useState} from 'react';
import {useUserProfile} from '../requests/use-user-profile';
import {
  useDeleteProfile,
  useGetProfiles,
  useSelectProfile,
} from '../requests/use-get-profiles';
import {useGetAvatarList} from '@app/titles/requests/use-avatar-list';
import {AccountCircleIcon} from '@common/icons/material/AccountCircle';
import {Add, Delete, Edit} from '@mui/icons-material';
import {AddCircle} from 'iconsax-react';
import {openDialog} from '@common/ui/overlays/store/dialog-store';
import AddProfileDialog from '@app/addProfileDialog';
import {Spinner} from 'react-bootstrap';
import {Trans} from '@common/i18n/trans';
import {useAuth} from '@common/auth/use-auth';
import {useParams} from 'react-router-dom';

function ProfileSubProfilesPanel() {
  const {user} = useAuth();
  const {userId} = useParams();

  const userQuery = useUserProfile();
  const profile = userQuery.data!.user;

  const getProfiles = useGetProfiles();
  const selectProfile = useSelectProfile();
  const deleteProfile = useDeleteProfile();

  return (
    <div>
      {user?.id.toString() === userId && (
        <div className="text-center text-2xl font-bold">
          <Trans message="Who is Watching?" />
        </div>
      )}
      <div className="flex items-center justify-center gap-[50px] py-[50px]">
        {getProfiles?.data?.map(item => (
          <div
            className="relative flex cursor-pointer flex-col items-center gap-14"
            onClick={() => selectProfile.mutate(item.id)}
          >
            <div
              className="absolute -right-10 -top-10"
              onClick={e => {
                e.stopPropagation();
                openDialog(AddProfileDialog);
                localStorage.setItem(
                  'default_profile',
                  JSON.stringify({
                    name: item.name,
                    avatarId: item.avatar_id,
                    age: item.type,
                    id: item.id,
                  }),
                );
              }}
            >
              <Edit />
            </div>
            {profile?.profiles && profile?.profiles[0]?.id !== item.id ? (
              <div
                className="absolute -left-10 -top-10"
                onClick={e => {
                  e.stopPropagation();
                  deleteProfile.mutate(item.id);
                }}
              >
                <Delete />
              </div>
            ) : null}

            {item.avatar ? (
              <img
                className="h-[120px] w-[120px] rounded-full"
                src={item?.avatar?.url}
                alt=""
              />
            ) : (
              <AccountCircleIcon className="h-[120px] w-[120px]" />
            )}
            <span
              className={`text-xl max-md:text-base ${profile?.profiles && profile?.profiles[0]?.id === item.id ? 'text-danger-darker' : 'text-white'}`}
            >
              {item.name}
            </span>
          </div>
        ))}
        {selectProfile.isPending ? <Spinner /> : null}
        {user?.id.toString() === userId && (
          <AddCircle
            className="h-[50px] w-[50px] cursor-pointer"
            onClick={() => openDialog(AddProfileDialog)}
          />
        )}
      </div>
    </div>
  );
}

export default ProfileSubProfilesPanel;
